<template>
    <div id="vip-pay" style="width: 100%;height: 500px;background-color: #FFEECC">
      <p>1111111=={{formHtml}}</p>
        <div id="form-html" style="width: 200px;height: 200px;background-color: yellowgreen;" v-html="formHtml">
        </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      formHtml: ''
    }
  },
  methods: {
    payForm: function (payUrl) {
      this.formHtml = payUrl
      console.log('支付宝支付==============================')
      setTimeout(function () {
        document.forms[0].submit()
      }, 500)
    }
  },
  comments: {
  },
  mounted () {
    if (this.utils.isIphone() === true) {
      window.payForm = this.payForm
    } else {
      var _this = this
      window['payForm'] = (result) => {
        _this.payForm(result)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/app/vip-pay.vue